<template>
    <a-modal centered :visible="visible" title="批量修改供应商" @ok="on_submit" @cancel="cancel" :confirmLoading="submitting" :width="420">
        <a-form-model :model="form" ref="trademark_supplier" :rules="rules">
            <div class="ids" v-if="record">
                <div style="color: #ff5722;margin-bottom:12px">已选择：{{ record.length }}个商标</div>
                <small>{{ this.record.map((v) => v.markName).join("，") }}</small>
            </div>

            <a-divider>修改供应商为</a-divider>

            <a-select
                class="spotlight"
                show-search
                :show-arrow="false"
                :dropdownMatchSelectWidth="false"
                placeholder="搜索供应商"
                :filter-option="false"
                @search="on_search"
                @change="on_select"
                option-label-prop="name"
                v-model="form.supplier_id"
            >
                <a-spin v-if="loading" slot="notFoundContent" size="small" />

                <a-select-opt-group v-for="d in data_supplier" :key="d.id">
                    <span slot="label"> {{ d.contact_name }} </span>
                    <a-select-option :key="d.id" :value="d.id" :name="d.contact_name" :item="d">
                        <div>
                            {{ d.contact_name }}
                        </div>
                    </a-select-option>
                </a-select-opt-group>
            </a-select>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        apply_nos: null,
        supplier_id: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                form: {},
                loading: false,
                data_supplier: [],
                rules: {
                    supplier_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入链接",
                        },
                    ],
                },
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    this.form.apply_nos = this.record.map((v) => v.applyNo);
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["trademark_supplier"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/trademark/batch_supplier", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$message.success(res.message);
                                }
                            })
                            .catch()
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_search(v) {
                this.loading = true;
                this.$http
                    .get(`/trademark/supplier?type=plain&wd=${v}`)
                    .then((response) => {
                        if (response.success) {
                            this.data_supplier = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_select(e) {},
            after_close() {
                this.$refs["trademark_supplier"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
